<template>
  <div class="historyCheckPage">
    <header class="header">
      <!-- 搜索条件 -->
      <Card>
        <Form>
          <Row :gutter="24">
            <FormItem>
              <Col :span="4">
                <Input type="text" v-model.trim="searchItem.name" :maxLength="50" @pressEnter="getHistoryList('search')" placeholder="姓名"/>
              </Col>
              <Col :span="4">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.dateType" allowClear placeholder="请选择日期类型" @change="getHistoryList('search')">
                  <Option v-for="(val) in searchItem.dateTypeList" :key="val.key" :value="val.key">{{val.value}}</Option>
                </Select>
              </Col>
              <Col :span="7">
                <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.startAEndTime" @change="getHistoryList('search')"></RangePicker>
              </Col>
              <Col :span="5">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.imageCenter" allowClear placeholder="请选择影像中心" @change="getHistoryList('search')">
                  <Option v-for="(val, index) in searchItem.imageCenterList" :key="index" :value="val.id">{{val.name}}</Option>
                </Select>
              </Col>
              <Col :span="4">
                <Select
                  :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }"
                  v-model.trim="searchItem.checkItem"
                  allowClear
                  placeholder="请选择设备类型"
                  @change="getHistoryList('search')">
                  <Option v-for="(val, index) in searchItem.checkItemList" :key="index" :value="val.body_id">{{val.body_name}}</Option>
                </Select>
              </Col>
            </FormItem>
          </Row>
          <Row :gutter="24">
            <FormItem>
              <Col :span="4">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.patientChannel" allowClear placeholder="请选择患者来源" @change="getHistoryList('search')">
                  <Option v-for="(val, index) in searchItem.patientChannelList" :key="index" :value="val.key">{{val.value}}</Option>
                </Select>
              </Col>
              <Col :span="4">
                <Select v-if="isRole('ROLE_RIS') && !isRole('ROLE_ROOT')" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.scanningState" allowClear mode="multiple" placeholder="请选择检查状态" @change="getHistoryList('search')">
                  <Option v-for="(val, index) in searchItem.nurseScanningStateList" :key="index" :value="val.key">{{val.value}}</Option>
                </Select>
                <Select v-else :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.scanningState" allowClear mode="multiple" placeholder="请选择检查状态" @change="getHistoryList('search')">
                  <Option v-for="(val, index) in searchItem.scanningStateList" :key="index" :value="val.key">{{val.value}}</Option>
                </Select>
              </Col>
              <Col :span="4">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="searchItem.checkBillStatus" allowClear placeholder="请选择对账状态" @change="getHistoryList('search')">
                  <Option v-for="(val, index) in searchItem.checkBillStatusList" :key="index" :value="val.key">{{val.value}}</Option>
                </Select>
              </Col>
              <Col :span="4">
                <Input type="text" v-model.trim="searchItem.bodyItemName" allowClear @pressEnter="getHistoryList('search')" placeholder="检查部位"/>
              </Col>
              <Col :span="8" :style="{ textAlign: 'right' }">
                <Button style="margin-right:16px" @click="exportExcel()" :loading="downLoading">导出</Button>
                <Button style="margin-right:16px" type="primary" @click="getHistoryList('search')">搜索</Button>
              </Col>
            </FormItem>
          </Row>
        </Form>
      </Card>
    </header>
    <!-- 列表展示 -->
    <article class="historyListContent">
      <Table :loading="showHistoryLoad" :dataSource="historyCheckList" :columns="columns" :pagination='false' rowKey="id" @change="changeTable">
        <template slot="patientName" slot-scope="text, record">
          <span>
            <span style="display: inline-block;" class="haveLine" @click="setPatientMsg(record)">{{record.patient_name}} {{record.emergency ? '(急)' : ''}}</span>
            <img src="https://webimage.tongxinyiliao.com/ris/images/printer.png" @click="printedReport(record.reportId)" style="margin-left: 10px;" v-if="record.is_printed" />
            <Icon type="edit" class="editMobileIcon" @click="openEditMobileModal(record)" />
          </span>
        </template>
        <template slot="patientType" slot-scope="text, record">
          <span class="haveLine" >{{record.medical_insurance ? '医保' : '自费'}}</span>
          <span class="haveLine" >{{record.outpatient_inpatient ? '门诊' : '住院'}}</span>
        </template>
        <template slot="patientChannel" slot-scope="text, record">
          <span class="haveLine" @click="editPatientChannel(record)">{{record.order_source}}</span>
        </template>
        <template slot="bodyItems" slot-scope="text, record">
          <p v-for="(val, index) in record.bodyItems" :key="index">
            {{val.alias || val.name}}{{val.count > 1 ? `*${val.count}` : ''}}
          </p>
        </template>
        <template slot="actualCost" slot-scope="text, record">
          <span class="haveLine" >{{record.price && record.price.toFixed(2)}}</span>
          <span class="haveLine" >{{record.charge_channel}}</span>
        </template>
        <template slot="totalAmount" slot-scope="text, record">
          <a class="haveLine" @click="openRefundFeeModal(record)">{{ record.totalAmount }}</a>
        </template>
        <template slot="additionalCost" slot-scope="text, record">
          <div v-if="record.extraOrderCheckOrderInfoDOList">
            <p v-for="(item, index) in record.extraOrderCheckOrderInfoDOList" :key="index">
              <span class="haveLine" @click="setAdditionalCost(record)">{{item.price}}</span>
              <span class="haveLine" @click="setAdditionalCost(record)">{{item.payTypeText}}</span>
            </p>
          </div>
          <span v-else class="haveLine" @click="setAdditionalCost(record)">0</span>
        </template>
        <template slot="scanningState" slot-scope="text, record">
          <p>{{getScanningStateValue(record.status)}}</p>
        </template>
        <template slot="remarks" slot-scope="text, record">
          <span class="haveLine" v-if="record.remark" @click="editRemarks(record)">{{record.remark}}</span>
          <Button v-else type="primary" size="small" @click="editRemarks(record)">编辑</Button>
        </template>
        <template slot="reconciliation" slot-scope="text, record">
          <Button type="primary" size="small" v-if="!record.reconciliation" @click="handleSurePrice(record)">核对</Button>
          <div v-else>
            <p>{{record.reconciliationName}}</p>
            <p>已对账</p>
          </div>
        </template>
      </Table>
    </article>
    <!-- 页脚内容 -->
    <footer class="footer">
      <div class="static">
        <span style="margin-right: 16px;">检查单数: {{checkOrderTotal}},</span>
        <span style="margin-right: 16px;">折算系数: {{reducedBodyTotal}},</span>
        <span style="margin-right: 16px;">医疗费用: {{medicalCost}},</span>
        <span style="margin-right: 16px;">实际费用: {{realCostTotal}},</span>
        <span style="margin-right: 16px;">额外费用: {{additionalCostTotal}},</span>
        <span>实收: {{realIncome}}</span>
      </div>
      <div class="page">
        <Pagination
          v-model="pageNumber"
          :pageSize.sync="pageSize"
          :showQuickJumper='true'
          :total="totalRecord"
          @change="searchHistoryList"
        />
      </div>
    </footer>
    <!-- 设置工作人 -->
    <Modal title="设置工作人" v-model="showSetWorker" :footer="null" :width="720" :height="520">
      <setWorker :checkId="checkId" @closeSetWorker="closeSetWorker" v-if="showSetWorker"></setWorker>
    </Modal>
    <!-- 额外费用 -->
    <Modal title="额外费用" v-model="showExtra" :footer="null" :width="680" class="modalFixdToTop">
      <extraCost v-if="showExtra" @closeExtraCost="closeExtraCost" :checkOrderId="checkOrderId" :disAdditionalCost="disAdditionalCost" :settlementStatus="settlementStatus"></extraCost>
    </Modal>
    <!-- 修改来源 -->
    <Modal title="选择患者来源" v-model="showChangeFrom" width="40%">
      <div>
        <Form>
          <FormItem label="患者来源：" style="display: flex;">
            <Button :disabled="disPatientChannel || (selectItem.order_source === '快诊' && val.value !== '快诊')" style="margin:0 0 16px 16px;" v-for="(val, index) in searchItem.patientChannelList" :key="index" size="large" :type="val.key === changeFromVal ? 'primary' : ''" @click="changePatientChannel(val.key)">{{val.value}}</Button>
          </FormItem>
        </Form>
      </div>
      <template slot="footer">
        <Button size="large" @click="closeChangeFrom">取消</Button>
      </template>
    </Modal>
    <!-- 匹配线下医生 -->
    <Modal title="匹配医生" v-model="showDoctorModal" :footer="null" :width="960">
      <matchDoctor v-if="showDoctorModal" @closeMatchDoctor="closeMatchDoctor" @noDoctorMate="noDoctorMate" @haveDoctorMate="haveDoctorMate"></matchDoctor>
    </Modal>
    <Modal title="添加备注信息" v-model="showChangeRemarks" width="40%">
      <TextArea v-model="remarks"/>
      <template slot="footer">
        <Button size="large" @click="closeRemarks">取消</Button>
        <Button size="large" type="primary" @click="sureSaveRemarks">确定</Button>
      </template>
    </Modal>
    <Modal title="修改手机号" v-model="editMobileModal.showModal" width="420px" :footer="null">
      <div style="display: flex; align-items: center; gap: 12px;">
        <Input v-model.trim="editMobileModal.mobile" placeholder="请输入手机号" :maxLength="11" />
        <Button type="primary" :loading="editMobileModal.saveLoading" @click="savePatientMobile">修改</Button>
      </div>
    </Modal>
    <Modal title="退费修改记录" v-model="refundFeeModal.showModal" width="40%" :confirm-loading="refundFeeModal.sureLoading" @ok="refundAction" >
      <Table :dataSource="refundFeeModal.list" :columns="refundFeeModal.tableCoolums" :pagination='false' rowKey="id">
        <template slot="editTime" slot-scope="text, record">
          <span v-if="record.payment_status == 20 && record.status == 20 && record.totalAmount > 0">{{ formateDate(new Date()) }}</span>
          <span v-else>{{ record.updated_date ? record.updated_date.substring(0, 10) : '' }}</span>
        </template>
        <template slot="actualAmount" slot-scope="text, record">
          <InputNumber v-if="record.payment_status == 20 && record.status == 20 && record.totalAmount > 0" @change="(val) => { setRefundAfterAmount(record, val)}" :min="0" style="width: 100%;"/>
          <span v-else>{{ record.totalAmount }}</span>
        </template>
        <template slot="refundReason">
          <span>检查后退费</span>
        </template>
        <template slot="operationPerson" slot-scope="text, record">
          <span v-if="record.payment_status == 20 && record.status == 20 && record.totalAmount > 0">{{ userInfo.real_name }}</span>
          <span v-else>{{ record.modifier }}</span>
        </template>
      </Table>
      <template slot="footer">
        <Button size="large" @click="() => { refundFeeModal.showModal = false; refundFeeModal.list = [] }">取消</Button>
        <Button v-if="refundFeeModal.list[0] && refundFeeModal.list[0].payment_status == 20 && refundFeeModal.list[0].status == 20 && refundFeeModal.list[0].totalAmount > 0" size="large" type="primary" @click="refundAction">确定</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import matchDoctor from '../addCheck/matchDoctorList'
import extraCost from './extraCost'
import setWorker from '../callNum/setWorker'
import { getAllBodyItem } from '../../api/check'
import { scanningStatus } from '../../core/filter'
import { getHistoryCheck, getStaticHistory, matchHistoryList, isQuestionOrder, getHistoryCheckStatistics, checkOrderRefundFee, updatePatientMobile } from '../../api/historyCheck'
import { checkPriceAndChangeRemarks, changeRemarks } from '../../api/onlineCheckin'
import { Form, Input, DatePicker, Select, Row, Col, Button, Table, Pagination, Card, Modal, InputNumber, Icon } from 'ant-design-vue'
import { toast, arrayUnqiue, getSession, setSession, getReservationDate, arrToJson, checkPhone } from '../../libs/utils'
import { mapState } from 'vuex'
import moment from 'moment'
import { fixTableHeader } from '../../libs/mixin'
import { changePrinter } from '../../api/report'
import { downLoadExcel } from '../../libs/tool'
import { isNumber } from 'lodash'
export default {
  mixins: [fixTableHeader],
  components: {
    Form,
    FormItem: Form.Item,
    Input,
    TextArea: Input.TextArea,
    RangePicker: DatePicker.RangePicker,
    Select,
    Option: Select.Option,
    Row,
    Col,
    Button,
    Icon,
    Table,
    Pagination,
    Card,
    Modal,
    setWorker,
    extraCost,
    matchDoctor,
    InputNumber
  },
  data () {
    return {
      searchItem: {
        name: '',
        checkNum: '',
        startAEndTime: [moment().subtract(30, 'days'), moment()],
        imageCenter: undefined,
        imageCenterList: [],
        checkItem: undefined,
        checkItemList: [],
        patientChannel: undefined,
        patientChannelList: [
          { key: '线下', value: '线下' },
          { key: '快诊', value: '快诊' },
          { key: '医院体检', value: '医院体检' },
          { key: '院内患者', value: '院内患者' },
          { key: '内部福利单', value: '内部福利单' },
          { key: '外部福利单', value: '外部福利单' },
          { key: '科研检查单', value: '科研检查单' }
        ],
        scanningState: [],
        nurseScanningStateList: [
          { key: 8, value: '预约完成' },
          { key: 20, value: '已完成' },
          { key: 50, value: '已扫描' },
          { key: 60, value: '扫描中' },
          { key: 10, value: '等待叫号' },
          { key: -20, value: '已取消' }
        ],
        scanningStateList: [
          { key: 0, value: '待接单' },
          { key: 5, value: '待定' },
          { key: 8, value: '预约完成' },
          { key: 20, value: '已完成' },
          { key: 50, value: '已扫描' },
          { key: 60, value: '扫描中' },
          { key: 10, value: '等待叫号' },
          { key: -20, value: '已取消' }
        ],
        dateType: 1,
        dateTypeList: [
          { key: 1, value: '预约日期' },
          { key: 2, value: '完成日期' },
        ],
        checkBillStatus: '0',
        checkBillStatusList: [
          { key: '', value: '全部' },
          { key: '1', value: '已对账' },
          { key: '0', value: '未对账' }
        ],
        sort: 'service_operation_datetime desc',
        bodyItemName: ''
      },
      pageNumber: 1,
      pageSize: 20,
      totalRecord: 0,
      historyCheckList: [],
      columns: [
        {
          title: '预约时间',
          dataIndex: 'service_appointment_actual_datetime',
          width: 110
        },
        {
          title: '影像中心',
          dataIndex: 'hospital_medical_image_center_name',
          width: 100
        },
        {
          title: '姓名',
          dataIndex: 'patientName',
          scopedSlots: { customRender: 'patientName' },
          width: 90
        },
        {
          title: '医保/患者类型',
          dataIndex: 'patientType',
          scopedSlots: { customRender: 'patientType' },
          width: 70
        },
        {
          title: '来源',
          key: 'patientChannel',
          dataIndex: 'patientChannel',
          scopedSlots: { customRender: 'patientChannel' },
          width: 90
        },
        {
          title: '检查部位',
          dataIndex: 'bodyItems',
          scopedSlots: { customRender: 'bodyItems' },
          width: 200
        },
        {
          title: '实际费用',
          dataIndex: 'actualCost',
          scopedSlots: { customRender: 'actualCost' },
          width: 100
        },
        {
          title: '额外费用',
          dataIndex: 'additionalCost',
          scopedSlots: { customRender: 'additionalCost' },
          width: 90
        },
        {
          title: '实收总计',
          scopedSlots: { customRender: 'totalAmount' },
          width: 90
        },
        {
          title: '折算系数',
          dataIndex: 'equivalent_count',
          width: 50
        },
        {
          title: '检查状态',
          dataIndex: 'scanningState',
          scopedSlots: { customRender: 'scanningState' },
          width: 80
        },
        {
          title: '检查时间',
          dataIndex: 'service_operation_datetime',
          width: 100,
          defaultSortOrder: 'descend',
          sortDirections: ['descend', 'ascend'],
          sorter: true
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          scopedSlots: { customRender: 'remarks' },
          width: 50
        },
        {
          title: '对账',
          dataIndex: 'reconciliation',
          scopedSlots: { customRender: 'reconciliation' },
          width: 50
        }
      ],
      checkOrderTotal: 0,
      reducedBodyTotal: 0,
      medicalCost: 0,
      realCostTotal: 0,
      additionalCostTotal: 0,
      realIncome: 0,
      showHistoryLoad: false,
      selectLoad: false,
      showSetWorker: false,
      checkId: null,
      showExtra: false,
      showPatientChannel: false,
      showDoctorModal: false, // 匹配快诊医生弹窗
      showOrderModal: false, // 匹配快诊订单弹窗
      showChangeFrom: false, // 修改患者来源弹窗
      changeFromVal: '', // 患者来源取值
      downLoading: false, // 导出loading
      checkOrderId: '', // 检查订单ID
      sendPatientInfo: {},
      role: null,
      disAdditionalCost: true,
      disPatientChannel: false,
      showComplete: false,
      selectItem: {},
      settlementStatus: '', // 结算状态
      showChangeRemarks: false, // 添加备注弹窗
      remarks: '',
      editRemarksId: '',
      editMobileModal: {
        showModal: false,
        mobile: '',
        record: null,
        saveLoading: false
      },
      refundFeeModal: {
        showModal: false,
        tableCoolums: [
          {
            title: '修改时间',
            scopedSlots: { customRender: 'editTime' },
            width: 100
          },
          {
            title: '修改前金额',
            dataIndex: 'pay_amount',
            width: 90
          },
          {
            title: '修改后金额',
            scopedSlots: { customRender: 'actualAmount' },
            width: 100
          },
          {
            title: '修改原因',
            scopedSlots: { customRender: 'refundReason' },
            width: 100
          },
          {
            title: '修改人',
            scopedSlots: { customRender: 'operationPerson' },
            width: 100
          }
        ],
        list: [],
        sureLoading: false
      },
      userInfo: {}
    }
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId,
      deviceList: state => state.app.devices
    })
  },
  methods: {
    // 搜索条件
    searchData () {
      let params = {}
      if (this.searchItem.imageCenter) params.medicalImageCenterId = this.searchItem.imageCenter
      if (this.searchItem.name) params.patientName = this.searchItem.name
      if (this.searchItem.startAEndTime && this.searchItem.startAEndTime.length > 0) {
        if (this.searchItem.dateType === 1) {
          params.startAppointmentDate = getReservationDate(this.searchItem.startAEndTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
          params.endAppointmentDate = getReservationDate(this.searchItem.startAEndTime[1]).format('YYYY-MM-DD') + ' 00:00:00'
        } else if (this.searchItem.dateType === 2) {
          params.startFinishDate = getReservationDate(this.searchItem.startAEndTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
          params.endFinishDate = getReservationDate(this.searchItem.startAEndTime[1]).format('YYYY-MM-DD') + ' 00:00:00'
        }
      }
      if (this.searchItem.checkItem) params.checkItemId = this.searchItem.checkItem
      if (this.isRole('ROLE_RIS') && this.searchItem.scanningState && this.searchItem.scanningState.length <= 0) {
        params.orderStatus = arrToJson([8, 10, 20, 50, 60, 10, -20])
      }
      if (this.searchItem.scanningState && this.searchItem.scanningState.length > 0) params.orderStatus = arrToJson(this.searchItem.scanningState)
      if (this.searchItem.patientChannel) params.orderSource = this.searchItem.patientChannel
      if (this.searchItem.checkNum) params.orderCode = this.searchItem.checkNum
      if (this.searchItem.checkBillStatus) params.reconciliation = this.searchItem.checkBillStatus
      if (this.searchItem.sort) {
        params.isHistoryList = true
        params.sort = this.searchItem.sort
      }
      if (this.searchItem.bodyItemName) params.bodyItemName = this.searchItem.bodyItemName
      return params
    },
    // 获取历史检查列表和统计数据
    async getHistoryList (type) {
      this.showHistoryLoad = true
      if (type === 'search') {
        this.pageNumber = 1
        setSession('searchHistoryData', this.searchItem)
      }
      if (isNumber(type)) {
        this.pageNumber = type
      }
      let params = Object.assign(this.searchData(), {
        pageNo: this.pageNumber,
        pageSize: this.pageSize,
      })
      let data = await getHistoryCheck(params)
      if (data) {
        this.historyCheckList = data.pageList.results
        this.forReportList(data.pageList.results)
        this.overMouth(data.pageList.results)
        this.totalRecord = data.pageList.totalRecord
        this.showHistoryLoad = false
      } else {
        this.historyCheckList = []
        this.showHistoryLoad = false
      }
      let staticsData = await getHistoryCheckStatistics(params)
      if (staticsData) {
        this.checkOrderTotal = staticsData.statistics.totalOrder
        this.reducedBodyTotal = staticsData.statistics.totalEquivalentCount
        this.medicalCost = staticsData.statistics.totalPrice
        this.realCostTotal = staticsData.statistics.totalRealPrice
        this.additionalCostTotal = staticsData.statistics.totalExtraPrice
        this.realIncome = staticsData.statistics.sumAllPrice
      }
    },
    // 遍历检查列表，待结算无法操作
    overMouth (arr) {
      arr && arr.forEach(val => {
        if (val.settlement_status === 0) {
          val.overTime = false
        } else {
          val.overTime = true
        }
      })
    },
    // 遍历检查列表 展示打印图标
    forReportList (arr) {
      if (arr && arr.length > 0) {
        arr.forEach(val => {
          val.reportList && val.reportList.forEach(key => {
            if (key.printed || key.printed === false) {
              val.reportId = key.reportId
              val.is_printed = true
              return
            }
          })
        })
      }
    },
    // 历史检查列表的分页
    async searchHistoryList (pageNumber) {
      await this.getHistoryList(pageNumber)
    },
    // 点击姓名
    setPatientMsg (params) {
      if (params.status === 8) {
        this.$router.push({ path: '/ris/addCheck', query: { checkOrderId: params.id, from: 'historyCheck', isNurseEditFlag: true } })
      }
      else this.$router.push({ path: '/ris/addCheck', query: { checkOrderId: params.id, from: 'historyCheck' } })
    },
    // 显示设置工作人画面
    setWorker (params) {
      if (params.settlement_status !== 0) return toast({msg: '当前检查非待结算，无法修改！'})
      this.checkId = { id: params.id, isCancel: true }
      if (params.status === 10) {
        return toast({ title: '提示', type: 'warning', msg: '检查状态为等待叫号的不能设置工作人！' })
      }
      if (params.overTime === false || this.isRole('ROLE_ROOT')) {
        this.showSetWorker = true
      }
    },
    // 关闭设置工作人弹框
    async closeSetWorker () {
      this.showSetWorker = false
      await this.getHistoryList()
    },
    // 设置额外费用
    async setAdditionalCost (record) {
      if (!record.overTime === false && !this.isRole('ROLE_ROOT')) this.disAdditionalCost = false
      else this.disAdditionalCost = true
      this.checkOrderId = record.id
      this.settlementStatus = record.settlement_status
      this.showExtra = true
    },
    // 导出检查订单信息
    async exportExcel () {
      this.downLoading = true
      let params = this.searchData()
      let data = await getStaticHistory(params)
      if (!data) return toast({ title: '提示', msg: '导出数据异常，请重试' })
      downLoadExcel(data)
      this.downLoading = false
    },
    // 处理扫描状态
    getScanningStateValue (num) {
      return scanningStatus(num)
    },
    // 获取当前影像中心
    getCheckImageCenter () {
      let imageList = getSession('userAuth', 'object')
      this.searchItem.imageCenterList = imageList && imageList.centerVos || []
    },
    // 根据影像中心获取检查设备列表
    async getClassType () {
      let check = await getAllBodyItem({ pageNumber: 1, pageSize: 999999 })
      if (check) {
        let arr = []
        check.results.forEach(val => {
          if (val.id) {
            arr.push({ body_id: val.id, body_name: val.name })
          }
        })
        this.searchItem.checkItemList = arrayUnqiue(arr, 'body_name')
      }
    },
    // 关闭选择来源
    closeChangeFrom () {
      this.showChangeFrom = false
    },
    // 点击渠道
    async changePatientChannel (name) {
      this.changeFromVal  = name
      await this.saveChangeFrom()
    },
    // 保存选择来源
    async saveChangeFrom (name) {
      let params = {
        id: this.checkOrderId,
        orderSource: this.changeFromVal
      }
      if (this.changeFromVal === '线下') { // 匹配线下订单
        this.matchingOffline()
      } else if (this.changeFromVal === '快诊') { // 匹配快诊订单
        this.matchingDiaOrder(name)
      } else {
        await matchHistoryList(params)
      }
      await this.getHistoryList()
      this.showChangeFrom = false
    },
    // 匹配线下医生
    matchingOffline () {
      this.showDoctorModal = true
    },
    // 匹配快诊订单
    matchingDiaOrder () {
      this.sendPatientInfo = {
        patient_name: '',
        gender: '',
        patient_phone: ''
      }
      this.showDoctorModal = true
    },
    // 无匹配医生
    async noDoctorMate () {
      let params = {
        id: this.checkOrderId,
        orderSource: this.changeFromVal
      }
      let data = await matchHistoryList(params)
      if (data) {
        this.showDoctorModal = false
        this.getHistoryList()
      }
    },
    // 匹配到医生
    async haveDoctorMate (doctor) {
      let params = {
        id: this.checkOrderId,
        doctorId: doctor.id,
        orderSource: this.changeFromVal
      }
      let data = await matchHistoryList(params)
      if (data) {
        this.showDoctorModal = false
        this.getHistoryList()
      }
    },
    closeMatchDoctor () {
      this.showDoctorModal = false
    },
    // 关闭额外费用的弹框
    async closeExtraCost () {
      this.showExtra = false
      await this.getHistoryList()
    },
    // 修改患者来源
    async editPatientChannel (record) {
      let data = await isQuestionOrder({ orderId: record.id })
      if (data.result && data.result.settlement_check_status === -1) {
        return toast({msg: `${data.result.settlement_check_status_name}已将该订单标为问题，暂无法匹配医生`, title: '提示', type: 'warning'})
      }
      if (record.settlement_status !== 0) return toast({msg: '当前检查非待结算，无法修改！'})
      this.selectItem = record
      if (!record.overTime === false && !this.isRole('ROLE_ROOT')) {
        this.disPatientChannel = true
      } else this.disPatientChannel = false
      this.showChangeFrom = true
      this.changeFromVal = record.order_source
      this.checkOrderId = record.id
    },
    editRemarks (record) {
      if (record.remark) {
        this.remarks = record.remark
      } else {
        this.remarks = ''
      }
      this.editRemarksId = record.id
      this.showChangeRemarks = true
    },
    openEditMobileModal (record) {
      this.editMobileModal.record = record
      this.editMobileModal.mobile = record.mobile || record.patient_mobile || record.patient_phone || ''
      this.editMobileModal.showModal = true
    },
    async savePatientMobile () {
      if (!checkPhone(this.editMobileModal.mobile)) {
        return toast({ msg: '请输入正确手机号', type: 'warning', title: '提示' })
      }
      const record = this.editMobileModal.record
      if (!record) return false
      if (this.editMobileModal.saveLoading) return false
      this.editMobileModal.saveLoading = true
      const flag = await updatePatientMobile({
        orderCheckOrderInfoId: record.id,
        mobile: this.editMobileModal.mobile
      })
      if (!flag) {
        this.editMobileModal.saveLoading = false
        return false
      }
      record.mobile = this.editMobileModal.mobile
      record.patient_mobile = this.editMobileModal.mobile
      record.patient_phone = this.editMobileModal.mobile
      toast({ msg: '手机号已更新', type: 'success', title: '提示' })
      this.editMobileModal.showModal = false
      this.editMobileModal.saveLoading = false
    },
    async sureSaveRemarks () {
      if (!this.remarks.trim()) return toast({msg: '请填写备注信息'})
      let data = await changeRemarks({ orderCheckId: this.editRemarksId, remark: this.remarks })
      if (data) {
        this.getHistoryList()
        this.showChangeRemarks = false
        this.remarks = ''
      }
    },
    closeRemarks () {
      this.showChangeRemarks = false
    },
    async handleSurePrice (record) {
      let data = await checkPriceAndChangeRemarks({ id: record.id })
      if (data) this.getHistoryList()
    },
    // 打印报告
    async printedReport (id) {
      let data = await changePrinter({ reportId: id })
      if (data) {
        this.$router.push({path: '/ris/printReport', query: { reportId: id }})
      }
    },
    // 判断角色
    isRole (code) {
      if (!this.role || this.role.length <= 0) return
      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].rcode === code) return true
      }
      return false
    },
    async changeTable (pagination, filters, sorter) {
      if (sorter.field === 'service_operation_datetime') {
        if (sorter.order === 'ascend') {
          this.searchItem.sort = 'service_operation_datetime asc'
        } else if (sorter.order === 'descend') {
          this.searchItem.sort = 'service_operation_datetime desc'
        } else {
          this.searchItem.sort = ''
        }
      }
      await this.getHistoryList()
    },
    formateDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    openRefundFeeModal (record) {
      this.refundFeeModal.showModal = true
      record.refundAfterAmount = ''
      this.refundFeeModal.list = [record]
    },
    setRefundAfterAmount (record, val) {
      if (!isNumber(val)) return toast({ msg: '填写金额不正确', type: 'error', title: '错误提示' })
      record.refundAfterAmount = val
    },
    async refundAction () {
      const record = this.refundFeeModal.list[0] || {}
      if (!isNumber(record.refundAfterAmount)) return toast({ msg: '请先填写退费后金额', type: 'error', title: '错误提示' })
      if (record.refundAfterAmount >= record.totalAmount) return toast({ msg: '修改后金额填写不正确', type: 'error', title: '错误提示' })
      if (this.refundFeeModal.sureLoading) return false
      this.refundFeeModal.sureLoading = true
      const params = {
        id: record.id,
        actualAmount: record.refundAfterAmount,
        historyAmount: record.totalAmount
      }
      const flag = await checkOrderRefundFee(params)
      if (flag) {
        toast({ msg: '操作成功', type: 'success', title: '操作提示' })
        this.refundFeeModal.showModal = false
        await this.getHistoryList()
      }
      this.refundFeeModal.sureLoading = false
    }
  },
  async mounted () {
    const userAuth = getSession('userAuth', 'object') || {}
    this.role = userAuth.roles
    this.userInfo = getSession('risUserInfo', 'object') || {}
    let search = getSession('searchHistoryData', 'object')
    let isNull = JSON.stringify(search) !== '{}'
    if (isNull && search) {
      if (search.imageCenter) this.searchItem.imageCenter = search.imageCenter
      if (search.name) this.searchItem.name = search.name
      if (search.dateType === 1) {
        this.searchItem.startAEndTime = [moment((search.startAEndTime[0])), moment((search.startAEndTime[1]))]
      } else {
        this.searchItem.startAEndTime = [moment((search.startAEndTime[0])), moment((search.startAEndTime[1]))]
      }
      if (search.checkItem) this.searchItem.checkItem = search.checkItem
      // 检查状态
      if (search.scanningState && search.scanningState.length > 0) {
        this.searchItem.scanningState = search.scanningState
      }
      if (search.patientChannel) this.searchItem.patientChannel = search.orderSource
      if (search.checkNum) this.searchItem.checkNum = search.orderCode
      if (search.checkBillStatus) this.searchItem.checkBillStatus = search.checkBillStatus
      if (search.patientChannel) this.searchItem.patientChannel = search.patientChannel
    }
    // 如果是护士状态
    if (this.isRole('ROLE_RIS') && this.searchItem.scanningState.length < 1) {
      this.searchItem.scanningState.push(20)
    }
    await this.getHistoryList()
    await this.getCheckImageCenter()
    await this.getClassType()
    this.handleTableScroll('.historyListContent')
  },
  destroyed () {
    this.removeHandleListener()
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.historyCheckPage{
  .header{
    margin: 10px @LeaveDistance;
    .ant-card-body{
      padding: @LeaveDistance 10px 0 10px;
      margin: 0 @LeaveDistance;
    }
    .ant-row{
      .ant-form-item{
        margin-bottom: @LeaveDistance;
      }
      .ant-col-4{
        padding-right: @LeaveDistance;
      }
      .ant-col-5{
        padding-right: @LeaveDistance;
      }
      .ant-col-6{
        padding-right: @LeaveDistance;
      }
      .ant-col-7{
        padding-right: @LeaveDistance;
      }
    }
  }
  .ant-calendar-picker{
    width: 100%;
  }
  @media all and (max-width: 1090px) {
    .footer{
      .static{
        margin: 15px 20px;
        display: inline-block;
      }
      .page{
        min-width: 364px;
        margin: 10px 20px;
        float: right;
      }
    }
    .historyListContent{
      width: 100%;
      overflow-y: scroll;
      height: calc(100vh - 302px);
      padding: 0 @LeaveDistance;
      .ant-table-wrapper{
        overflow: auto;
        .ant-table-thead >tr >th , .ant-table-tbody >tr > td{
          padding: 12px 10px;
        }
      }
      table{
        background-color: #fff;
      }
      .haveLine{
        display: block;
        color: @primaryColor;
        text-decoration: underline;
      }
      p{
        margin: 0;
        padding: 0;
      }
    }
  }
  @media all and (min-width: 1090px) {
    .footer{
      .static{
        margin-top: 15px;
        margin-left: 20px;
        display: inline-block;
      }
      .page{
        margin-top: 10px;
        margin-right: 20px;
        float: right;
      }
    }
    .historyListContent{
      overflow-y: scroll;
      height: calc(100vh - 272px);
      padding: 0 @LeaveDistance;
      .ant-table-wrapper{
        overflow: auto;
        .ant-table-thead >tr >th , .ant-table-tbody >tr > td{
          padding: 12px 10px;
        }
      }
      table{
        background-color: #fff;
      }
      .haveLine{
        display: block;
        color: @primaryColor;
        text-decoration: underline;
      }
      p{
        margin: 0;
        padding: 0;
      }
    }
  }
  .ant-select-selection--multiple .ant-select-selection__rendered {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__rendered ul {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-search--inline {
    float: none;
    position: absolute;
  }
  .ant-select-selection--multiple {
    max-height: 32px;
    overflow: hidden;
  }
  .ant-btn{
    position: static;
  }
  .editMobileIcon{
    margin-left: 10px;
    color: @primaryColor;
    cursor: pointer;
  }
  .ant-select-selection--multiple{
    margin-top: 4px;
  }
}
</style>
